<template>
<div class="chapter">
<div class="inner_page">
<div id="Frontmatter">
<p class="fig-img"><img alt="" class="image" src="images/ufig_1.jpg"/></p>
<p class="fig-caption">This stylized illustration from the cover of a French magazine published in October 1937 depicts a resolute Nationalist Chinese soldier looking into the distance. The caption says that this is a ‘typical Chinese soldier fighting against the Japanese in defence of Shanghai’. World opinion was generally on the side of the Chinese in 1937 as they were seen as victims of Japanese aggression.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Frontmatter.vue?79961e48